<template>
    <TipBox info :title="$t('tips.open_hours.title')">
        <p v-html="$t('tips.open_hours.description')"></p>
        <ul>
            <li v-html="$t('tips.open_hours.description_li_1')"></li>
            <li v-html="$t('tips.open_hours.description_li_2')"></li>
        </ul>
    </TipBox>
</template>

<script>
    export default {
      name: "TipsOpenHours"
    }
</script>